import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import shtickle from "../../Assets/Projects/shtickle.png";
import Instant from "../../Assets/Projects/instant.png";
import Emoji from "../../Assets/Projects/emojiGame3.png";
import speedsterlogo from "../../Assets/Projects/iconSpeed.png";
import yoomlogo from "../../Assets/Projects/yoomlogo.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={speedsterlogo}
              title="Speedster!"
              description="
Developed a React Native app with a Firebase backend, featuring a competitive matching game with four mini-games: 1-minute challenge, speed round, duel, and multiplayer. Included a live leaderboard, in-game coin rewards to unlock emoji packs, and multiplayer options for both public and private matches."
              ghLink="https://github.com/jacobboim/kesharim"
              demoLink="https://apps.apple.com/us/app/speedster/id1663425972"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={shtickle}
              title="Shtickle"
              description="Designed a React Native word game app where users guess the word within six attempts.
              Dynamic color changes on tiles provide visual feedback, and users can share results with friends similar to Wordle, enhancing
              social and competitive dimensions."
              ghLink="https://github.com/jacobboim/Shtickle-app"
              demoLink="https://apps.apple.com/us/app/shtickle/id1644797670"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={yoomlogo}
              title="Yoom"
              description="Developed a Next.js application that functions as a global video chat platform, mimicking Zoom. This app enables live video interactions with users worldwide, featuring real-time communication, and seamless user interface for an engaging virtual meeting experience."
              ghLink="https://github.com/jacobboim/zoom_clone"
              demoLink="https://zoom-clone-boim.vercel.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Instant}
              title="Instant Connect"
              description="Produced a group messaging platform using React and Firebase backend. Users can create and join chat rooms and send messages."
              ghLink="https://github.com/jacobboim/InstantConnect"
              demoLink="https://instantconnect.netlify.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Emoji}
              title="Emoji Matching Game"
              description="Created an emoji matching memory game using React. Challenge your memory skills and have fun!"
              ghLink="https://github.com/jacobboim/memory-game"
              demoLink="https://emojis-memory-game.netlify.app/"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
